import { type PropsWithChildren, forwardRef } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./ExactnessButton.module.scss";

interface ExactnessButtonProps extends PropsWithChildren {
    isExact: boolean;
    testId: string;
    ariaLabel?: string;
    onClick: () => void;
}

export const ExactnessButton = forwardRef<HTMLButtonElement, ExactnessButtonProps>(
    ({ isExact, testId, children, ariaLabel, onClick }, ref) => {
        const { t } = useTranslation();

        return (
            <button
                ref={ref}
                type="button"
                className={classNames("link icon", styles.exactnessButton, {
                    iconCheck: isExact,
                    [styles.inputBox!]: !isExact,
                })}
                onClick={onClick}
                aria-label={ariaLabel}
                data-testid={testId}
            >
                {children ?? t("exactText")}
            </button>
        );
    },
);

ExactnessButton.displayName = "ExactnessButton";
